import { system, compose } from './system-core.esm.js';
import { isNumber } from '../utils/assertion.esm.js';
import { memoizedGet } from '../utils/object.esm.js';
import { resolveSizeValue } from '../utils/size-utils.esm.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
var defaults = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var resolveMargin = function resolveMargin(n, scale, props) {
  var v = resolveSizeValue(props.theme || props)(n, 'sizes.space');
  if (!isNumber(v)) {
    return memoizedGet(scale, v, v);
  }
  var isNegative = Number(v) < 0;
  var absolute = Math.abs(v);
  var value = memoizedGet(scale, absolute, absolute);
  if (!isNumber(value)) {
    return isNegative ? '-' + value : value;
  }
  return Number(value) * (isNegative ? -1 : 1);
};
var getSpacing = function getSpacing(n, scale, props) {
  var v = resolveSizeValue(props.theme || props)(n, 'sizes.space');
  return memoizedGet(scale, v, v);
};
var configs = {};
configs.margin = {
  margin: {
    property: 'margin',
    scale: 'space',
    transform: resolveMargin,
    defaultScale: defaults.space
  },
  marginTop: {
    property: 'marginTop',
    scale: 'space',
    transform: resolveMargin,
    defaultScale: defaults.space
  },
  marginRight: {
    property: 'marginRight',
    scale: 'space',
    transform: resolveMargin,
    defaultScale: defaults.space
  },
  marginBottom: {
    property: 'marginBottom',
    scale: 'space',
    transform: resolveMargin,
    defaultScale: defaults.space
  },
  marginLeft: {
    property: 'marginLeft',
    scale: 'space',
    transform: resolveMargin,
    defaultScale: defaults.space
  },
  marginX: {
    properties: ['marginLeft', 'marginRight'],
    scale: 'space',
    transform: resolveMargin,
    defaultScale: defaults.space
  },
  marginY: {
    properties: ['marginTop', 'marginBottom'],
    scale: 'space',
    transform: resolveMargin,
    defaultScale: defaults.space
  }
};
configs.margin.m = configs.margin.margin;
configs.margin.mt = configs.margin.marginTop;
configs.margin.mr = configs.margin.marginRight;
configs.margin.mb = configs.margin.marginBottom;
configs.margin.ml = configs.margin.marginLeft;
configs.margin.mx = configs.margin.marginX;
configs.margin.my = configs.margin.marginY;
configs.padding = {
  padding: {
    property: 'padding',
    scale: 'space',
    transform: getSpacing,
    defaultScale: defaults.space
  },
  paddingTop: {
    property: 'paddingTop',
    scale: 'space',
    transform: getSpacing,
    defaultScale: defaults.space
  },
  paddingRight: {
    property: 'paddingRight',
    scale: 'space',
    transform: getSpacing,
    defaultScale: defaults.space
  },
  paddingBottom: {
    property: 'paddingBottom',
    scale: 'space',
    transform: getSpacing,
    defaultScale: defaults.space
  },
  paddingLeft: {
    property: 'paddingLeft',
    scale: 'space',
    transform: getSpacing,
    defaultScale: defaults.space
  },
  paddingX: {
    properties: ['paddingLeft', 'paddingRight'],
    scale: 'space',
    transform: getSpacing,
    defaultScale: defaults.space
  },
  paddingY: {
    properties: ['paddingTop', 'paddingBottom'],
    scale: 'space',
    transform: getSpacing,
    defaultScale: defaults.space
  }
};
configs.padding.p = configs.padding.padding;
configs.padding.pt = configs.padding.paddingTop;
configs.padding.pr = configs.padding.paddingRight;
configs.padding.pb = configs.padding.paddingBottom;
configs.padding.pl = configs.padding.paddingLeft;
configs.padding.px = configs.padding.paddingX;
configs.padding.py = configs.padding.paddingY;
var margin = system(configs.margin);
var padding = system(configs.padding);
var space = compose(margin, padding);

export default space;
export { defaults, getSpacing, margin, padding, resolveMargin, space };
//# sourceMappingURL=space.esm.js.map
